/** Utilitários de CPF compartilhados entre cliente e servidor. */

export const cpfDigits = (raw: string | null | undefined) => (raw ?? "").replace(/\D/g, "");

export function isValidCpf(raw: string | null | undefined): boolean {
  const v = cpfDigits(raw);
  if (v.length !== 11 || /^(\d)\1{10}$/.test(v)) return false;
  const calc = (len: number) => {
    let sum = 0;
    for (let i = 0; i < len; i++) sum += Number(v[i]) * (len + 1 - i);
    const d = (sum * 10) % 11;
    return d === 10 ? 0 : d;
  };
  return calc(9) === Number(v[9]) && calc(10) === Number(v[10]);
}

export function formatCpf(raw: string | null | undefined): string {
  const v = cpfDigits(raw).slice(0, 11);
  return v
    .replace(/^(\d{3})(\d)/, "$1.$2")
    .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4");
}
